import { EntityModel } from '@/interfaces'
import {
  ALL_IMAGE_BLOCKS_QUERY,
  CREATE_IMAGE_BLOCK_MUTATION,
  DELETE_IMAGE_BLOCK_MUTATION,
  FORCE_DELETE_IMAGE_BLOCK_MUTATION,
  SINGLE_IMAGE_BLOCK_QUERY,
  UPDATE_IMAGE_BLOCK_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const cmsImageBlockModel: EntityModel = {
  name: 'imageBlock',
  namePlural: 'imageBlocks',
  uniqueName: 'cmsImageBlock',
  uniqueNamePlural: 'cmsImageBlocks',
  path: 'cms/blocks/image_block',
  baseUrl: '/cms/blocks/image_blocks',
  translationPrefix: 'entities:cmsImageBlock.',
  getDisplayName: (values: any) => {
    return 'Image Block'
  },
  gql: {
    getAll: ALL_IMAGE_BLOCKS_QUERY,
    getSingle: SINGLE_IMAGE_BLOCK_QUERY,
    create: CREATE_IMAGE_BLOCK_MUTATION,
    update: UPDATE_IMAGE_BLOCK_MUTATION,
    delete: DELETE_IMAGE_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_IMAGE_BLOCK_MUTATION,
  },
  attributes: {
    image: {
      name: 'image',
      label: 'entities:cmsImageBlock.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    text: {
      name: 'text',
      label: 'entities:cmsImageBlock.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    fluid: {
      name: 'fluid',
      label: 'entities:cmsImageBlock.attributes.fluid.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsImageBlockModel
